var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 42,
    viewBox: "0 0 33 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.375V6.1875H12.375V12.375H8.25ZM8.25 30.9375V20.625H12.375V30.9375H8.25ZM4.125 41.25C2.99062 41.25 2.01987 40.8464 1.21275 40.0393C0.405625 39.2322 0.001375 38.2607 0 37.125V4.125C0 2.99062 0.40425 2.01987 1.21275 1.21275C2.02125 0.405625 2.992 0.001375 4.125 0H28.875C30.0094 0 30.9808 0.40425 31.7893 1.21275C32.5978 2.02125 33.0014 2.992 33 4.125V37.125C33 38.2594 32.5964 39.2308 31.7893 40.0393C30.9822 40.8478 30.0107 41.2514 28.875 41.25H4.125ZM4.125 37.125H28.875V18.5625H4.125V37.125ZM4.125 14.4375H28.875V4.125H4.125V14.4375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenIcon);
export default __webpack_public_path__ + "static/media/KitchenIcon.bead9f1de894737bf797ac532fb6ed85.svg";
export { ForwardRef as ReactComponent };